import _ from 'lodash';

export default function selector(storeState) {
    const { brands, loading } = _.get(storeState, 'flexBrandsDashboard') || {};

    return {
        brands,
        loading,
    };
}
